
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17.676 13.322"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_34579","data-name":"Group 34579","transform":"translate(-1794.449 -237.629)"}},[_c('rect',{attrs:{"id":"Rectangle_9544","data-name":"Rectangle 9544","width":"16.676","height":"12.322","rx":"2.472","transform":"translate(1794.949 238.129)","fill":"none","stroke":"#a8a8a8","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"1"}}),_c('path',{attrs:{"id":"Path_21136","data-name":"Path 21136","d":"M14.521 11.45l-3.81-2.2a.613.613 0 00-.92.531v4.4a.614.614 0 00.92.531l3.81-2.2a.613.613 0 000-1.063","transform":"translate(1790.979 232.308)","fill":"#a8a8a8"}})])])
          )
        }
      }
    